import { createUseStyles } from "react-jss";
import * as Mixins from "../../../theme/Mixins";

export default createUseStyles({
    icon: {
        composes: "error__icon",
        display: "inline-block",
        fontSize: 30,
        marginRight: 14.5,
        verticalAlign: "middle",
    },
    errorContainer: {
        background: ({ theme }) => theme.ErrorColor,
        borderRadius: 10,
        color: ({ theme }) => Mixins.foregroundColor(theme, theme.ErrorColor),
        composes: "error__container",
        margin: [[14.5, 0]],
        padding: [[9.67, 14.5]],
    },
    errorMessage: {
        composes: "error__message",
        fontWeight: 700,
        verticalAlign: "middle",
    },
});
